import { LoadingView } from "@mittwald/flow-components/dist/components/Box";
import { Section } from "@mittwald/flow-components/dist/components/Section";
import { Text } from "@mittwald/flow-components/dist/components/Text";
import { TranslationProvider } from "@mittwald/flow-components/dist/components/TranslationProvider";
import React from "react";
import { CodeInput } from "../../../../../../components/CodeInput";
import type { AnimationController } from "@mittwald/flow-components/dist/hooks/useAnimationController";
import Suspense from "@mittwald/flow-lib/dist/resources/Suspense";

interface DeviceCookieStepProps {
  rejectionAnimation: AnimationController;
}

export const DeviceCookieStepContent: React.FC<DeviceCookieStepProps> = (
  props,
) => {
  const { rejectionAnimation } = props;

  return (
    <TranslationProvider name="deviceCookieStepContent" type="component">
      <Suspense loadingView={<LoadingView _height={250} />}>
        <Section.Item headline="deviceCookie">
          <Text i18n="deviceCookieText" />
          <CodeInput
            label="deviceCookie"
            maxLength={8}
            name="deviceCookie"
            rejectionAnimation={rejectionAnimation}
          />
        </Section.Item>
      </Suspense>
    </TranslationProvider>
  );
};
